import React from 'react';

import { css } from '@emotion/react';
import { colors, Primitive } from '@rtkwlf/fenrir-react';

export type CardProps = Omit<
  React.ComponentProps<typeof Primitive.div>,
  'boxShadow'
> & {
  boxShadow?: React.ComponentProps<typeof Primitive.div>['boxShadow'] | 'none';
};

export const Card = React.memo(
  React.forwardRef<HTMLDivElement, CardProps>(
    (
      {
        children,
        boxShadow = 'default',
        padding = 'small',
        ...otherProps
      }: CardProps,
      ref,
    ) => {
      return (
        <Primitive.div
          ref={ref}
          boxShadow={boxShadow === 'none' ? undefined : boxShadow}
          padding={padding}
          borderRadius="default"
          backgroundColor="widgetDefault"
          css={css({
            '@media print': {
              border: '1px solid',
              borderColor: `rgb(${colors.accent.grey.secondary})`,
              boxShadow: 'none',
            },
            display: 'flex',
            flexDirection: 'column',
          })}
          {...otherProps}
        >
          {children}
        </Primitive.div>
      );
    },
  ),
);
